import { FC, MouseEvent } from "react";
import { css, styled } from "@mui/material";
import { Input, TInputProps } from "@/components/elements/Input/Input";

type ClickableDisableInputProps = TInputProps & {
  onClickForDisableInput?: (e: MouseEvent<HTMLInputElement>) => void;
};

export const ClickableDisableInput: FC<ClickableDisableInputProps> = ({ readonly = true, onClickForDisableInput, ...rest }) => {
  const handleClick = (e: MouseEvent<HTMLInputElement>) => {
    if (readonly && onClickForDisableInput) {
      onClickForDisableInput(e);
    }
  };

  const enableClickableStyle = readonly && !!onClickForDisableInput;

  return <StyledClickableInput {...rest} readonly={readonly} onClick={handleClick} enableClickableStyle={enableClickableStyle} />;
};

//prettier-ignore
const StyledClickableInput = styled(Input, {
  shouldForwardProp: (prop) => prop !== "enableClickableStyle",
})<{ enableClickableStyle?: boolean }>`
  ${({ enableClickableStyle }) =>
    enableClickableStyle &&
    css`
      cursor: pointer;
      input {
        text-decoration: underline;
      }
    `}
`;
